module.exports = __webpack_public_path__ + "static/media/halo-auto-illus.03626c20.svg";